import { useContext } from 'react';

import steps from './steps';
import CreateNewAccountButton from './createNewAccount/CreateNewAccountButton';
import { Context } from '../Provider';

const Nav = () => {
    const { state } = useContext(Context);
    const { step } = state;

    return (
        <div className="card position-sticky top-1">
            <ul className="nav flex-column bg-white border-radius-0-2 p-3">
                {steps.filter(item => item.stepId !== 0).map(item => (
                    <li className="nav-item pt-2" key={item.stepId || item.stepHref}>
                        <a className="nav-link text-dark d-flex" href={item.stepHref}>
                            <i className="material-icons text-lg me-2" style={{ color: item.stepColor }}>
                                {item.stepIcon}
                            </i>
                            <span className="text-sm">
                                {item.stepName} &nbsp;&nbsp;
                                {item.stepId <= step?.stepId && (
                                    <i className="material-icons text-lg me-2" style={{ color: 'green' }}>
                                        check_box
                                    </i>
                                )}
                            </span>
                        </a>
                    </li>
                ))}

                <hr className="dark horizontal my-3 hide-on-mobile"/>

                <li className="nav-item pt-2 hide-on-mobile">
                    <CreateNewAccountButton/>
                </li>
            </ul>
        </div>
    );
};

export default Nav;